$(->
  $('#app_applicant_attributes_country').on 'change', ->
    if $(this).val() == 'AE'
      $('#app_applicant_attributes_zip_input').hide()
    else
      $('#app_applicant_attributes_zip_input').show()
)
